import React, {ReactNode} from "react";
import {Dialog} from "primereact/dialog";
import PortalDialogType from "../../PortalDialogType";
import {Button} from "primereact/button";
import Translate from "../../../../shared/translation/Translate";
import Icon from "../../../../shared/components/Icon";
import AbstractDialog, {
	AbstractDialogProperties,
	AbstractDialogState
} from "../../../../shared/dialog/components/AbstractDialog";

export interface ConfirmZipExtractionDialogProperties extends AbstractDialogProperties {
	accept: () => Promise<void>;
}

export class ConfirmZipExtractionDialogDefinition extends AbstractDialog<ConfirmZipExtractionDialogProperties,
	AbstractDialogState> {
	public renderDialog(): ReactNode {
		let classList: Array<string> = ["zip-confirmation-dialog"];
		if (this.state.submitted) {
			classList.push("submitted");
		}

		return (
			<Dialog className={classList.join(" ")} visible={this.props.visible} onHide={this.hide}
					closeOnEscape={true} header={this.renderHeader()} footer={this.renderFooter()}
					resizable={false} appendTo={document.getElementById("root")}>
				<div className="p-grid">
					{this.renderError()}
					<fieldset className="p-col-12 p-grid">
						<div className="dialog-message">
							<Translate {...this.props} data="zip.message" namespace="dialog"/>
						</div>
					</fieldset>
				</div>
			</Dialog>
		);
	}

	protected renderHeader(): ReactNode {
		return (
			<div>
				<h1>
					<Icon icon={"icon-archive small"}/>
					<Translate {...this.props} data="zip.title" namespace="dialog"/>
				</h1>
				<Button icon="icon icon-close" onClick={() => this.hide()}/>
			</div>
		);
	}

	protected renderFooter(): ReactNode {
		return (
			<div>
				<Button label={Translate.value("buttons.yes")} className="primary-button"
						icon={"icon" + (this.state.submitted ? " icon-spinner spin" : " icon-check")}
						disabled={!this.isValid()} onClick={() => this.submit()}/>
				<Button label={Translate.value("buttons.no")} icon="icon icon-close" onClick={() => this.hide()}
						className="dialog-button"/>
			</div>
		);
	}

	protected isValid(): boolean {
		if (!this.mounted || !this.props.visible) {
			return false;
		}

		return !this.state.submitted;
	}

	protected async submit(): Promise<void> {
		await super.submit();

		await this.props.accept();
		this.hide();
	}

	protected getDialogType(): PortalDialogType {
		return PortalDialogType.ZIP_CONFIRMATION;
	}
}

const ConfirmZipExtractionDialog = React.memo(ConfirmZipExtractionDialogDefinition,
	(
		prevProps: Readonly<ConfirmZipExtractionDialogProperties>,
		nextProps: Readonly<ConfirmZipExtractionDialogProperties>
	) => {
		if (!nextProps.visible && !prevProps.visible) {
			return true
		}

		return false;
	}
);

export default ConfirmZipExtractionDialog;